<template>
  <transition name="fade" mode="out-in">
    <div v-if="message" class="app-alert" role="alert">
      <div>
        <div :class="`alert alert-${type} mb-0 alert-pop`" title="Click to dismiss" style="cursor: pointer" @click="dismiss">{{ message }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '@/store/EventBus'

export default {
  name: 'AppAlert',
  data() {
    return {
      message: null,
      type: 'warning',
      timer: null
    }
  },
  created() {
    this._onError = msg => this.show(msg, 'warning', true)
    this._onPersistentError = msg => this.show(msg, 'warning', false)
    this._onSuccess = msg => this.show(msg, 'success', true)
    EventBus.$on('http-error', this._onError)
    EventBus.$on('http-error-persistent', this._onPersistentError)
    EventBus.$on('show-success', this._onSuccess)
  },
  beforeDestroy() {
    EventBus.$off('http-error', this._onError)
    EventBus.$off('http-error-persistent', this._onPersistentError)
    EventBus.$off('show-success', this._onSuccess)
    clearTimeout(this.timer)
  },
  methods: {
    // Click on the message closes it right away
    dismiss() {
      clearTimeout(this.timer)
      this.message = null
    },
    apply(msg, autoDismiss) {
      this.message = msg
      this.$nextTick(() => {
        if (this.$el) this.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
      if (autoDismiss) {
        this.timer = setTimeout(() => { this.message = null }, 5000)
      }
    },
    show(msg, type, autoDismiss) {
      clearTimeout(this.timer)
      this.type = type
      if (this.message != null) {
        this.message = null
        this.$nextTick(() => this.apply(msg, autoDismiss))
      } else {
        this.apply(msg, autoDismiss)
      }
    }
  }
}
</script>

<style scoped>
.app-alert {
  padding: 1rem 0;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AppAlert.vue